export default "/static/images/bus.png?18daa0360a7a1387b669c9d9bb4c1b69";